import React from 'react';
import { Routes, Route, Navigate, useLocation, Outlet } from 'react-router-dom';

import FormsListPage from '@/pages/FormsListPage';
import FormBuilderPageInner from '@/pages/FormBuilderPage';
import PublicFormView from '@/pages/PublicFormView';
import LoginPage from '@/pages/LoginPage';
import ProfilePage from '@/pages/ProfilePage';
import UsersAdminPage from '@/pages/admin/UsersAdminPage';
import TenantsAdminPage from '@/pages/admin/TenantsAdminPage';
import AppLayout from '@/components/layout/AppLayout';

interface AuthGuardProps {
  children?: React.ReactNode;
}

const isAuthenticated = () =>
  typeof window !== 'undefined' && Boolean(localStorage.getItem('mks_forms_token'));

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children ? <>{children}</> : <Outlet />;
};

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/form/:formName" element={<PublicFormView />} />

      <Route element={<AuthGuard><AppLayout /></AuthGuard>}>
        <Route path="/forms" element={<FormsListPage />} />
        <Route path="/forms/new" element={<FormBuilderPageInner />} />
        <Route path="/forms/:formId/edit" element={<FormBuilderPageInner />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/admin/users" element={<UsersAdminPage />} />
        <Route path="/admin/tenants" element={<TenantsAdminPage />} />
      </Route>

      <Route path="/" element={<Navigate to={isAuthenticated() ? '/forms' : '/login'} replace />} />
      <Route path="*" element={<Navigate to={isAuthenticated() ? '/forms' : '/login'} replace />} />
    </Routes>
  );
};

export default App;
